import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/predplatne" as const,
	[Locale.en]: "/subscriptions" as const,
} satisfies LocalizedString;

export function getSubscriptionListingPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
